export enum OrderPointCategory {
  LOADING = 'loading',
  UNLOADING = 'unloading',
  CHECKPOINT = 'checkpoint',
  TRANSIT = 'transit',
  PICKUP = 'pickup',
}
